import React from "react";
import PropTypes from "prop-types";
import { Switch } from "react-router-dom";
import PrivateRoute from "components/PrivateRoute";
import { useFormBuilderScripts } from "hooks";
import FormBuilderView from "containers/Form/Builder/Builder";
import RulesOldMainView from "containers/RulesOld/Main";
import RulesMainView from "containers/Rules/Main";
import FormHistoryView from "containers/Form/History";
import FormListView from "containers/Form/List";

const FormMainView = ({ match }) => {
    useFormBuilderScripts();

    return (
        <div data-component="Form\FormMainView">
            <Switch>
                <PrivateRoute
                    exact
                    path={`${match.path}/:formId/oldrules2`}
                    component={RulesOldMainView}
                />
                <PrivateRoute
                    exact
                    path={`${match.path}/:formId/rules`}
                    component={RulesMainView}
                />
                <PrivateRoute
                    exact
                    path={`${match.path}/:formId/history`}
                    component={FormHistoryView}
                />
                <PrivateRoute
                    exact
                    path={`${match.path}/:formId/:preview?`}
                    component={FormBuilderView}
                />
                <PrivateRoute
                    exact
                    path={`${match.path}`}
                    component={FormListView}
                />
            </Switch>
        </div>
    );
};

FormMainView.propTypes = {
    match: PropTypes.shape({
        path: PropTypes.string,
    }),
};

export default FormMainView;
